import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import api from '@/api/org';

type Visible<T> = {
  recharge: T,
  contract: T,
  module: T,
  package: T,
  exam: T,
}

type Title<T> = {
  recharge: T,
  contract: T,
  module: T,
  package: T,
  exam: T,
}

type CompName = 'Account' | 'Contract' | 'Course' | 'Exam';

@Component
export default class OperateMixin extends Vue {
  @State(state => state.org.orgUid) orgUid!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  public title: Title<string> = {
    recharge: '充值',
    contract: '合同',
    module: '模块管理',
    package: '课包分配',
    exam: '试卷分配'
  };

  public visible: Visible<boolean> = {
    recharge: false,
    contract: false,
    module: false,
    package: false,
    exam: false,
  };

  /**
   * @author liangyongmou
   * @desc 打开充值模态框
   */
  public handleRecharge() {
    this.title.recharge = '充值';
    this.visible.recharge = true;
  }

  /**
   * @author liangyongmou
   * @desc 打开充值模态框
   */
  public handleReserve() {
    this.title.recharge = '对充';
    this.visible.recharge = true;
  }

  /**
   * @author liangyongmou
   * @desc 打开添加合同模态框
   */
  public handleAddContract() {
    this.title.contract = '合同签约';
    this.visible.contract = true;
  }

  /**
   * @author liangyongmou
   * @desc 打开模块模态框
   */
  public handleModule() {
    this.title.module = '模块管理';
    this.visible.module = true;
  }

  /**
   * @author liangyongmou
   * @desc 打开课包分配模态框
   */

  public handlePackage() {
    this.title.package = '课包分配';
    this.visible.package = true;
  }
  /**
   * @author Terry
   * @description 查看账户明细
   */
  public handleQueryAccount() {
    this.handleToggleComp('Account');
  }

  public handleExam() {
    this.title.exam = '试卷分配';
    this.visible.exam = true;
  }

  /**
   * @author Terry
   * @description 查看合同明细
   */
  public handleQueryContract() {
    this.handleToggleComp('Contract');
  }

  /**
   * @author Terry
   * @description 查看课包记录
   */
  public handleQueryCourse() {
    this.handleToggleComp('Course');
  }

  public handleQueryExam() {
    this.handleToggleComp('Exam');
  }

  /**
   * @author Terry
   * @description 切换当前激活组件
   * @param v
   */
  handleToggleComp(v: CompName) {
    this.setCurComp(v);
  }

  /**
  * @author liangyongmou
  * @desc 重置密码操作
  */
  handleResetPwd() {
    this.confirm('你确定为该机构重置密码吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.resetOrgPwd({ id: this.$route.params.pid || '' }).then(() => {
        close();
        this.$log({
          title: '机构管理 - 重置密码 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 重置密码 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
